import type { QuestionData } from '@repo/types/questions/Question';

import QuestionItemHeader from '@/components/features/quiz/quiz-resolver/QuestionItemHeader';
import { Element } from '@/components/ui/scroll';

import { QuestionContentType } from '.';

interface QuestionContentProps {
  question: QuestionData;
  questionIndex: number;
  sectionIndex: number;
  showMarked: boolean;
}

export function QuestionContent(questionContentProps: QuestionContentProps) {
  const { question, questionIndex, sectionIndex, showMarked } = questionContentProps;

  return (
    <Element name={`section-${sectionIndex}/question-${questionIndex}`} asChild>
      <div className="border-border-primary bg-surface-primary space-y-6 rounded-2xl border p-2">
        <QuestionItemHeader questionIndex={questionIndex} type={question.type} />
        <QuestionContentType question={question} questionIndex={questionIndex} sectionIndex={sectionIndex} showMarked={showMarked} />
      </div>
    </Element>
  );
}
